import { Record, List } from 'immutable';

export const MindPatternsData = new Record({
  id: null,
  isNew: true,
  isPending: false,
  error: 0,
  items: new List(),
});
